import { h, Component } from 'preact';
import axios from 'axios';
import { findDOMNode } from 'react-dom'
import ReactPlayer from 'react-player'
import { route } from 'preact-router';
import style from './style.css';
import Helmet from "preact-helmet";
import screenfull from 'screenfull'

export default class ChannelComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      currentChannel: 0,
      playing: true,
      volume: 0.5,
      pauses: {},
      startTime: Date.now(),
      isLoaded: true,
      numberOfChannels: 0
    };
  }

  componentDidMount() {
    const { slug, channel } = this.props

    axios.get('https://kstv-ch.now.sh/channels.json')
    .then(res => {
      const data = res.data.records

      let currentChannel = 0

      if (channel) {
        const number = Number(channel) - 1
        if (Number.isInteger(number) && number >= 0 && number <= data.length - 1) {
          currentChannel = number
        }
      }

      this.setState({
        data,
        currentChannel: currentChannel,
        numberOfChannels: data.length,
      }, this.updateUrl)
    })
    .catch((error) => {
      console.log(error);
    });

    window.addEventListener("keydown", this.listenForKeyPress, false);
  }

  componentWillUnmount() {
    window.removeEventListener("keypress", this.listenForKeyPress, false);
  }

  listenForKeyPress = e => {
    const { keyCode } = e
    const { currentVideoIndex, currentChannel, data, numberOfChannels } = this.state

    switch (keyCode) {
      case 37:
      return this.changeChannel(currentChannel - 1 >= 0 ? currentChannel - 1 : numberOfChannels - 1)
      case 39:
       return this.changeChannel(currentChannel + 1 <= numberOfChannels - 1 ? currentChannel + 1  : 0)
       case 40:
          return this.changeChannel(currentChannel - 1 >= 0 ? currentChannel - 1 : numberOfChannels - 1)
       case 38:
          return this.changeChannel(currentChannel + 1 <= numberOfChannels - 1 ? currentChannel + 1  : 0)
      default:
          return 
    }
  }

    onClickFullscreen = () => {
    screenfull.request(findDOMNode(this.player))
  }

  changeChannel = (nextChannel) => {
    const { pauses, currentVideoIndex, currentChannel } = this.state

    this.setState({
      currentChannel: nextChannel !== 'guide' ? nextChannel : currentChannel,
      isLoaded: false,
      playing: true,
      pauses: {
        ...pauses,
        [`${currentChannel}-${currentVideoIndex}`]: this.player ? this.player.getCurrentTime() : 0
      }
    },
    () => {
      if (nextChannel === 'guide') {
        route('/ch/guide', false)
      } else {
        this.updateUrl()
      }
    })
  }

  stopButton = () =>
    this.setState({
      playing: false
    })

  playButton = () =>
    this.setState({
      playing: true
    })

  volumeButton = (step) =>
    this.setState({
      volume: this.state.volume + step
    })

  updateUrl = (force = false) => {
    const { currentChannel, data } = this.state

    const { channel } = this.props

    if (channel !== 'guide' || force) {
      route(`/ch/${currentChannel + 1}`, false)
    }
  }

  checkIfWatched = () => {
    const { currentChannel, currentVideoIndex, pauses } = this.state
    const timeStopped = pauses && pauses[`${currentChannel}-${currentVideoIndex}`]

    if (timeStopped) {
      this.player.seekTo(timeStopped)
    }
  }

  onSeekMouseDown = e => {
    this.setState({ seeking: true })
  }

  onSeekChange = e => {
    this.setState({ played: parseFloat(e.target.value) })
  }

  onSeekMouseUp = e => {
    this.setState({ seeking: false })
    this.player.seekTo(parseFloat(e.target.value))
  }

  onProgress = state => {
    // We only want to update time slider if we are not currently seeking
    if (!this.state.seeking) {
      this.setState({played: state.played})
    }
  }

  onGuideStart = () => {
    const { startTime } = this.state

    const currentTime = (Date.now() - startTime) / 1000

    this.player2.seekTo(currentTime)
  }

  onYoutubeClick = (currentVideo) => {
    if (!this.player) {
      return currentVideo.fields.yt_link
    } else {
      return currentVideo.fields.yt_link.split('&t=')[0] + '&t=' + Math.floor(this.player.getCurrentTime()) + 's'
    }
  }
  
  render({}) {
    const { data, currentChannel, played, isLoaded, numberOfChannels } = this.state
    const { channel } = this.props
    console.log(numberOfChannels)

    if (channel === 'guide') {
      return (
        <div className={style.buddy__inner}>
        
     
          <Helmet title="Guide" />
        
          {!isLoaded && <div class={style.loadBoyzGuide}>Loading...</div>}

          <div class={style.player}>
         
          <div class={style.playerInner}>
          <div class={style.playerInnerGuide}>
            <ReactPlayer
            id="player"
              url="https://www.youtube.com/watch?v=m6vnT7Ur6DI"
              playing={this.state.playing}
              className={style.guideVid}
              volume={this.state.volume}
              controls={false}
              config={{
                youtube: {
                  playerVars: { modestbranding: 1, controls: 0, rel: 0, showinfo: 0 }
                }
              }}
              ref={c => {this.player2 = c}}
              onStart={this.onGuideStart}
              onReady={() => setTimeout(() => this.setState({isLoaded: true, playing: true}), 500)}
            />
        
          <ul class={style.all}>
            {data.map((video, i) => (
              <li key={i}>
                <a onClick={() => this.setState({currentChannel: i, isLoaded: false, playing: false}, () => this.updateUrl(true))}>
                <div class={style.chnN}>{i + 1} </div><div class={style.name}> {video.fields.Name}</div>
                </a>
              </li>
            ))}
            <br /><br />
           <img  onClick={() =>   route(`/ch/${currentChannel + 1}`, false)} class={style.guide} src="assets/gui.png" />
          </ul>
</div>



       <div class={style.mobile}>   
       <div class={style.buttons}>
       <div class={style.guideBtnDiv}>
<button class={style.guide} onClick={() =>   route(`/ch/${currentChannel + 1}`, false)}>
<img class={style.guide} src="assets/gui.png" />
<br/><br/>
<span>back to CH. {currentChannel + 1}</span>
</button>
       </div> 
      <div class={style.guideTopButtons}>
   

  <div class={style.marqueeBtnDiv}>

  <div class={style.marquee}>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentChannel.Name}</span>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentChannel.Name}</span>

</div>


</div>

<div class={style.seekBtnDiv}>

<input
        type='range' min={0} max={1} step='any'
        value={played}
        onMouseDown={this.onSeekMouseDown}
        onChange={this.onSeekChange}
        onMouseUp={this.onSeekMouseUp}
      />
  
  </div>
  </div>
  <div class={style.guideBottomButtons}>
  <div class={style.playBtnDiv}>
      <button onClick={this.playButton}><img src="https://kstv-buttons.now.sh/play.png" /></button>
      <button onClick={this.stopButton}><img src="https://kstv-buttons.now.sh/pause.png" /></button> 
    </div>
    <div class={style.navBtnDiv}>
      <button onClick={() => this.changeChannel(currentChannel - 1 >= 0 ? currentChannel - 1 : numberOfChannels - 1)}><img src="https://kstv-buttons.now.sh/prev.png" /></button>
      <button onClick={() => this.changeChannel(currentChannel + 1 <= numberOfChannels - 1 ? currentChannel + 1  : 0)}><img src="https://kstv-buttons.now.sh/next.png" /></button>
  
      <button onClick={this.onClickFullscreen}><img src="https://kstv-buttons.now.sh/full.png" /></button>
      <a target="_blank" href={currentChannel.yt_link}> <img src="https://kstv-buttons.now.sh/yt.png"/></a>
      </div>
    </div>
    </div>
        </div>
        </div>
          </div>
    
        </div>
      )
    }

    if (!data.length) {
      return <div>Loading...</div>
    }

    const currentVideo = data[currentChannel]

    if (!currentVideo) {
      return <div>Oops, something went wrong</div>
    }

    return (
      <div className={style.buddy__inner}>
    

      <Helmet 
      title={"ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}
   
      meta={[
       {name: "description", content: `{ "ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}`},
       {property: "og:type", content: "YES"},
       {name: "apple-mobile-web-app-capable", content: "article"},
       {property:"og:image" , content:"https://media.giphy.com/media/Yqn9tE2E00k4U/giphy.gif"},
       {property:"og:description" , content: `{ "ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}`},
       {key:"facebook-title" , property:"og:title" , content: `{ "ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}`},
       {key:"facebook-description" , property:"og:description" , content: `{ "ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}`},
       {key:"facebook-image", property:"og:image" , content:"https://media.giphy.com/media/Yqn9tE2E00k4U/giphy.gif"},
       {key:"facebook-url" , property:"og:url" , content: `{ "ch. " + [currentChannel + 1] + " | " + currentVideo.fields.Name}` }
      ]}
      />
   
      {!isLoaded && <div class={style.loadBoyz}>Loading...</div>}
      <div class={style.player}>
      
      <div class={style.playerInner}>
          <ReactPlayer
            ref={c => {this.player = c}}
            url={currentVideo.fields.yt_link}
            playing={this.state.playing}
            controls={false}
            config={{
              youtube: {
                playerVars: { modestbranding: 1, controls: 0, rel: 0, showinfo: 0 }
              }
            }}
            youtubeConfig={{ playerVars: { rel: 0 } }}
            onStart={this.checkIfWatched}
            className={style.vid}
            volume={this.state.volume}
            onProgress={this.onProgress}
            onReady={() => setTimeout(() => this.setState({isLoaded: true, playing: true}), 500)}
            onEnded={() => this.changeChannel(currentChannel + 1 <= numberOfChannels - 1 ? currentChannel + 1  : 0)}
          />
      <div class={style.buttons}>
      <div class={style.guideBtnDiv}>
    <button class={style.guide} onClick={() => this.changeChannel('guide')}>
    <img class={style.guide} src="assets/gui.png" /><br/><br/>
    <span>Guide</span>
  
    </button>
</div>
      <div class={style.guideTopButtons}>


  <div class={style.marqueeBtnDiv}>

  <div class={style.marquee}>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentVideo.fields.Name}</span>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentVideo.fields.Name}</span>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentVideo.fields.Name}</span>
<span>   <b>ch.{currentChannel + 1}  </b> - {currentVideo.fields.Name}</span>
</div>


</div>

<div class={style.seekBtnDiv}>

<input
        type='range' min={0} max={1} step='any'
        value={played}
        onMouseDown={this.onSeekMouseDown}
        onChange={this.onSeekChange}
        onMouseUp={this.onSeekMouseUp}
      />
  
  </div>
  </div>
  <div class={style.guideBottomButtons}>
  <div class={style.playBtnDiv}>
      <button onClick={this.playButton}><img src="https://kstv-buttons.now.sh/play.png" /></button>
      <button onClick={this.stopButton}><img src="https://kstv-buttons.now.sh/pause.png" /></button> 
    </div>
    <div class={style.navBtnDiv}>
      <button onClick={() => this.changeChannel(currentChannel - 1 >= 0 ? currentChannel - 1 : numberOfChannels - 1)}><img src="https://kstv-buttons.now.sh/prev.png" /></button>
      <button onClick={() => this.changeChannel(currentChannel + 1 <= numberOfChannels - 1 ? currentChannel + 1  : 0)}><img src="https://kstv-buttons.now.sh/next.png" /></button>
  
      <button class={style.mobile} onClick={this.onClickFullscreen}><img src="https://kstv-buttons.now.sh/full.png" /></button>
     <button> <a target="_blank" href={this.onYoutubeClick(currentVideo)}> <img src="https://kstv-buttons.now.sh/yt.png"/></a></button>
      </div>
    </div>
    </div>

         </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ChannelComponent.js